// ===========================================================================================

//import server                 from './server'
import util                   from './common/AppUtil'

import Login                  from './views/Login.vue'
import ChangePassword         from './views/ChangePassword.vue'
import NotFound               from './views/404.vue'
import Home                   from './views/Home.vue'
import Main                   from './views/Main.vue'

// -------------------------------------------------------------------------------------------

import Maintenance          from './views/admin/maintenance.vue'

// -------------------------------------------------------------------------------------------

import XProfile               from './views/system/xprofile.vue'
import XUser                  from './views/system/xuser.vue'
import XData                  from './views/system/xdata.vue'
import XNews                  from './views/system/xnews.vue'
import XShowNews              from './views/system/xshownews.vue'
import XCode                  from './views/system/xcode.vue'
import XLog                   from './views/system/xlog.vue'

// -------------------------------------------------------------------------------------------
import DbcLoad                from './views/dbc/dbcload.vue'
import DbcCheck               from './views/dbc/dbccheck.vue'

// -------------------------------------------------------------------------------------------
import Site                   from './views/admin/site.vue'
import Anvr                   from './views/admin/anvr.vue'
import Supplier               from './views/admin/supplier.vue'
import Dossier                from './views/admin/dossier.vue'
import DossierPaged           from './views/admin/dossierPaged.vue'
//import DossierXml             from './views/admin/Dossier_xml.vue'
//import DossierDetail          from './views/admin/Dossier_detail.vue'
import DossierImport          from './views/admin/Dossier_import.vue'
import View                   from './views/admin/view.vue'



import XStat                  from './views/admin/xstat.vue'
import XSanity                from './views/admin/xsanity.vue'

//import Tosparam               from './views/admin/tosparam.vue'
import Reports                from './views/admin/report.vue'
//import DataCopy               from './views/admin/DataCopy.vue'
// -------------------------------------------------------------------------------------------

let routes = [
  { path: '/login'         ,component: Login         ,name: '',hidden: true, qid:'XLI', dept:'', role:''},
  { path: '/changepassword',component: ChangePassword,name: '',hidden: true, qid:'XWW', dept:'', role:''},
  { path: '/404'           ,component: NotFound      ,name: '',hidden: true, qid:'X404',dept:'', role:''},
  { path: '*'              ,redirect: { path: '/404' }        ,hidden: true},

/* { path: '/mp3'           ,beforeEnter() {location.href = 'http://localhost:5000'}},*/

  { path: '/',
    component: Home,
    redirect: '/main',
    name: 'BAS Services',
    iconCls: 'el-icon-s-order',
    dept: 'BAS FIN',
    role: '',
    children: [
        { path: '/main'           ,component: Main            ,name: 'Welcome'                   ,qid: "W"   ,dept:'BAS', role:'', hidden: true},
        { path: '/dossier'        ,component: Dossier         ,name: 'Overview BAS Dossiers'     ,qid: "DOS" ,dept:'BAS FIN', role:''},
        { path: '/supplier'       ,component: Supplier        ,name: 'Maintain BAS Suppliers'    ,qid: "SUP" ,dept:'BAS', role:''},
        { path: '/site'           ,component: Site            ,name: 'Maintain BAS Sites'        ,qid: "S"   ,dept:'BAS', role:'admin'},
        { path: '/anvr'           ,component: Anvr            ,name: 'Maintain ANVR codes'       ,qid: "ANV" ,dept:'BAS', role:''},
        { path: '/view'           ,component: View            ,name: 'Define Report Views'       ,qid: "RV"  ,dept:'BAS', role:'admin'},
        { path: '/reports'        ,component: Reports         ,name: 'View BAS Reports'          ,qid: "REP" ,dept:'BAS FIN', role:''},
        { path: '/dossierImport'  ,component: DossierImport   ,name: 'Import Bas Dossier'        ,qid: "IMP" ,dept:'BAS', role:'', hidden: true },
        { path: '/stat_BAS'       ,component: XStat           ,name: 'Load BAS Statistics'       ,qid: "STD"  ,dept:'BAS', role:''},
    ]
  },
  

  { path: '/',
    component: Home,
    name: 'Newskies - DBC',
    iconCls: 'el-icon-s-opportunity',
    dept: 'JDB',
    role: '',
    children: [
        //{ path: '/stat_JDB'      ,component: XStat           ,name: 'Load DBC Statistics'       ,qid: "STC"  ,dept:'JDB', role:'',param:'XXXXXXYYYYYYY'},        
        { path: '/dbcload'     ,component: DbcLoad         ,name: 'View DBC Load stats'          ,qid: "DBC" ,dept:'JDB', role:''},
        { path: '/dbccheck'    ,component: DbcCheck        ,name: 'Online Booking Check'         ,qid: "DBCC" ,dept:'JDB', role:''},
        
      ]
  },
  
  { path: '/',
    component: Home,
    name: 'WRD Testing',
    iconCls: 'el-icon-s-flag',
    dept: 'BAS FIN',
    role: 'admin',
    children: [
        { path: '/dossierPaged'   ,component: DossierPaged    ,name: 'Browse BAS Dossiers'       ,qid: "DOSX" ,dept:'BAS FIN', role:'admin'},
    ]
  },


        
  { path: '/',
    component: Home,
    name: 'System Admin',
    iconCls: 'el-icon-s-tools',
    dept: '', 
    role: 'lead admin super',
    children: [
        { path: '/sanity'         ,component: XSanity         ,name: 'System Sanity Check'       ,qid: "SC"  ,dept:'', role:'', role:'admin super'},
        { path: '/logs'           ,component: XLog            ,name: 'Application Logs'          ,qid: "XLG"  ,dept:'', role:'admin lead'},
        { path: '/maint'          ,component: Maintenance     ,name: 'App Maintenance'           ,qid: "MAINT",dept:'WRD', role:'admin'},
  //    { path: '/datacopy  '     ,component: DataCopy        ,name: 'Bas DataCopy'              ,qid: "DCP" ,dept:'', role: 'admin super'},

  //    { path: '/tosparam'       ,component: Tosparam        ,name: 'Maintain TOS Params'       ,qid: "TP"  ,dept:'', role:'admin'},
        { path: '/xdata'          ,component: XData           ,name: 'Data Snippets'             ,qid: "XD"  ,dept:'', role:'admin lead'},
        { path: '/xnews'          ,component: XNews           ,name: 'App News'                  ,qid: "XN"  ,dept:'', role:'admin lead'},
        { path: '/xcodes'         ,component: XCode           ,name: 'Generic Codes'             ,qid: "XCD" ,dept:'', role:'admin lead'},
        { path: '/users'          ,component: XUser           ,name: 'Users'                     ,qid: "XU"  ,dept:'', role:'admin super'},
        { path: '/shownews'       ,component: XShowNews       ,name: 'Latest News'               ,qid: "XL"  ,dept:'', role:'', hidden: true},
        { path: '/profile'        ,component: XProfile        ,name: 'User Profile'              ,hidden: true, qid:'PRO', dept:'', role:''},
      ]
  },
];



// ---------------------------------------------------------------------------------------------------------------   

export default routes;




// WEBPACK FOOTER //
// ./src/routes.js